import axios from 'axios';
import api from '../api/axios';
import { toast } from 'react-hot-toast';
import { getbaseURL } from '../api/axios';

// Load the Easebuzz checkout script dynamically
const loadEasebuzzScript = () => {
    return new Promise((resolve, reject) => {
        if (window.EasebuzzCheckout) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Easebuzz script.'));
        document.body.appendChild(script);
    });
};
export const loadCashfreeScript = () => {
    return new Promise((resolve, reject) => {
        // If already loaded, resolve immediately
        if (window.Cashfree) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";  // Cashfree SDK URL
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error("Failed to load Cashfree script."));
        document.body.appendChild(script);
    });
};


// Load the ATOM checkout script dynamically
const loadAtomScript = () => {
    return new Promise((resolve, reject) => {
        if (window.AtomPaynetz) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://pgtest.atomtech.in/staticdata/ots/js/atomcheckout.js';
        // script.src = 'https://psa.atomtech.in/staticdata/ots/js/atomcheckout.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load ATOM script.'));
        document.body.appendChild(script);
    });
};

// Function to initiate payment
export const initiateEasebuzzPayment = async (paymentDetails) => {
    await loadCashfreeScript();
    // await loadAtomScript();
    try {
        // 1. Get access_key from your backend
        const response = await api.post(
            `${getbaseURL()}/initiate_payment`,
            paymentDetails,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        const accessKey = response.data.accesskey;
        const order_id = response?.data?.order_id || '';
        const enviroment = response?.data?.enviroment || 'test';
        const ActivePG = response?.data?.ActivePG || '4';
        const key = response?.data?.key || '4';

        if (!accessKey) {
            toast.error('Access key not received from backend.', { autoClose: 2000 });
            throw new Error("Access key not received from backend.");
        }

        // 2. Load the Easebuzz script dynamically
        await loadEasebuzzScript();



        // 3. Return the access key and payment details for the component to handle
        return {
            enviroment,
            accessKey,
            paymentDetails,
            timestamp: new Date().toISOString(),
            ActivePG: ActivePG,
            order_id: order_id,
            key: key,
        };

    } catch (error) {
        toast.error('Payment initiation failed', { autoClose: 2000 });
        console.error('Payment initiation failed:', error);
        throw new Error(error.response?.data?.message || 'Payment initiation failed');
    }
};

// Function to actually open the payment modal (to be called from component)
export const openEasebuzzPaymentModal = (enviroment, accessKey, paymentDetails, onResponseCallback) => {
    if (!window.EasebuzzCheckout) {
        throw new Error('Easebuzz script not loaded');
    }

    const easebuzzCheckout = new window.EasebuzzCheckout(accessKey, enviroment); // Use 'prod' for production

    const options = {
        access_key: accessKey,
        onResponse: function (response) {
            // console.log('Easebuzz onResponse callback triggered:', response);

            // Ensure the callback is properly called
            if (typeof onResponseCallback === 'function') {
                onResponseCallback(response);
            }
            setTimeout(() => {
                const killAll = () => {
                    document
                        .querySelectorAll('[id^="easebuzz-container-"], [id^="easebuzz-checkout-"], iframe[src*="easebuzz"]')
                        .forEach(n => n.remove());
                };
                killAll();
            }, 300);
        },
        onClose: function () {
            // console.log('Payment modal closed by user');
        },
        theme: '#123456',
        // Add other payment details as needed
        ...paymentDetails
    };
    easebuzzCheckout.initiatePayment(options);
};

export const openCashfreePaymentModal = async (
    environment,        // "sandbox" or "production"
    paymentSessionId,   // from your backend create order API
    paymentDetails,      // any extra Cashfree options
    onResponseCallback,  // callback with result
) => {
    // 1) Ensure Cashfree SDK is loaded
    if (!window.Cashfree) {
        throw new Error("Cashfree SDK not loaded");
    }

    try {
        // 2) Initialize Cashfree
        const cashfree = window.Cashfree({
            mode: environment, // e.g., "sandbox"
        });

        // 3) Prepare checkout options
        const checkoutOptions = {
            paymentSessionId,
            redirectTarget: "_modal",  // popup iframe
            ...paymentDetails,
        };

        // 4) Open modal
        const result = await cashfree.checkout(checkoutOptions);
        console.log(result);

        if (result.error) {
            // If there is an error returned (modal closed or cancel)
            console.log("Cashfree Error/Cancel:", result.error);
            onResponseCallback(result);

        } else if (result.paymentDetails && Object.keys(result.paymentDetails).length) {
            const response = await api.post(
                `${getbaseURL()}/payment/verify`,
                paymentDetails,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (typeof onResponseCallback === 'function') {
                onResponseCallback(response.data);
            }
        } else {
            // Cancel / no meaningful result
            console.log("Cashfree modal closed/cancelled - no payment");
            onResponseCallback(result);
        }
        // if (result.paymentDetails) {
        //     const response = await api.post(
        //         `${getbaseURL()}/payment/verify`,
        //         paymentDetails,
        //         {
        //             headers: {
        //                 "Content-Type": "application/json",
        //             },
        //         }
        //     );
        //     if (typeof onResponseCallback === 'function') {
        //         onResponseCallback(response.data);
        //     }
        // }
        // 5) Handle callback data
        // 6) Optional: remove any leftover Cashfree DOM (like Easebuzz)
        setTimeout(() => {
            document
                .querySelectorAll('iframe[src*="sdk.cashfree.com"], [id*="cashfree"]')
                .forEach((el) => el.remove());
        }, 300);

        return result;

    } catch (error) {
        console.error("Cashfree modal error", error);
        throw error;
    }
};

// Function to open the ATOM payment modal
export const openAtomPaymentModal = (atomTokenId, merchId, env, paymentDetails) => {
    if (!window.AtomPaynetz) {
        throw new Error('ATOM script not loaded');
    }

    let custEmail = paymentDetails.email
    let custMobile = paymentDetails.phone
    let returnUrl = paymentDetails?.surl || ''
    const options = { atomTokenId, merchId, custEmail, custMobile, returnUrl };

    // No onResponse/onClose callback exists here (unlike Easebuzz/Cashfree) —
    // ATOM completes the flow by POSTing to returnUrl from inside its own iframe.
    // See backend note below for why this matters.
    new window.AtomPaynetz(options, env); // env: 'uat' or 'live'

    // Optional cleanup once payment flow ends — inspect devtools for ATOM's actual
    // iframe/container id (unlike easebuzz-container-*, ATOM's isn't publicly documented)
    // and add a similar teardown here once you confirm the selector.
};

// Function to verify payment (to be called from your backend)
export const verifyPayment = async (transactionData) => {
    try {
        const response = await axios.post(
            "http://localhost:3000/verify_payment",
            transactionData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Payment verification failed');
    }
};